export default __webpack_public_path__ + "static/media/bg-mid.70b188a7.png";